<template>
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M7 -4.76837e-07C10.8692 -1.38579e-07 14 3.13105 14 7C14 10.8692
      10.8689 14 7 14C3.13078 14 -8.15072e-07 10.8689 -4.76837e-07 7C-1.38579e-07
      3.13078 3.13105 -8.15072e-07 7 -4.76837e-07ZM7 12.9062C10.2647 12.9062 12.9062
      10.2644 12.9062 7C12.9062 3.73535 10.2644 1.09375 7 1.09375C3.73535 1.09375 1.09375
      3.73557 1.09375 7C1.09375 10.2647 3.73557 12.9062 7 12.9062Z" fill="#F63B3B"/>
    <path d="M7 3.52441C7.30204 3.52441 7.54687 3.76925 7.54687 4.07129V7.59297C7.54687
      7.895 7.30204 8.13984 7 8.13984C6.69796 8.13984 6.45312 7.895 6.45312
      7.59297V4.07129C6.45312 3.76925 6.69796 3.52441 7 3.52441Z" fill="#F63B3B"/>
    <path d="M7 10.2861C6.59226 10.2861 6.26172 9.95559 6.26172 9.54785C6.26172 9.14011
      6.59226 8.80957 7 8.80957C7.40774 8.80957 7.73828 9.14011 7.73828 9.54785C7.73828
      9.95559 7.40774 10.2861 7 10.2861Z" fill="#F63B3B"/>
  </svg>
</template>

<script>
export default {
  name: 'BBPIconExclamationPoint'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPIcons/BBPIconExclamationPoint.vue